import * as React from "react"
import Header from "./header"
import Footer from "./footer"
import "../styles.css"
import CookieConsent from "react-cookie-consent"

interface LayoutProps {
  title: string
  description?: string
  image?: { id: string; url: string }
  children: React.ReactElement | React.ReactElement[]
}

const Layout: React.FC<LayoutProps> = (props) => {
  return (
    <>
      {/*<Head {...props} />*/}
      <Header />
      {props.children}
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="Akzeptieren"
        cookieName="fco-cookie-consent"
        style={{ background: "#336633" }}
        buttonStyle={{
          background: "#fff",
          color: "#336633",
          fontSize: "14px",
          borderRadius: "10px",
          padding: "10px 20px",
          fontWeight: "500",
        }}
        expires={150}
      >
        Durch die weitere Nutzung der Seite stimmst du der Verwendung von
        Cookies zu.
      </CookieConsent>
    </>
  )
}

export default Layout
